import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = ({ phone, message }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Utiliser le numéro depuis les settings ou fallback
  const phoneNumber = phone || '33610164337';
  
  const whatsappMessage = encodeURIComponent(
    message || "Bonjour Heelpy, je souhaite obtenir une estimation pour le rachat de mon appareil."
  );
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;
  
  // Ne pas afficher le bouton si pas de numéro
  if (!phone) return null;
  
  return (
    <>
      {/* Bouton flottant */}
      <div className="heelpy-whatsapp fixed bottom-6 right-6 z-50" data-testid="whatsapp-widget">
        {isOpen && (
          <div className="heelpy-whatsapp-panel mb-4 bg-white rounded-2xl shadow-2xl p-4 w-72 animate-in slide-in-from-bottom duration-300" data-testid="whatsapp-contact-panel">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Heelpy</p>
                  <p className="text-xs text-green-600 flex items-center gap-1">
                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                    En ligne
                  </p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="heelpy-whatsapp-close text-gray-400 hover:text-gray-600"
                aria-label="Fermer le contact WhatsApp"
                data-testid="whatsapp-contact-close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <p className="text-sm text-gray-700 mb-3">
              Besoin d'une estimation rapide ? Contactez-nous sur WhatsApp ! 💬
            </p>
            <a data-cta="true" data-testid="cta-whats-app-button-start-conversation"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-xl text-center transition-colors duration-200"
            >
              Démarrer la conversation
            </a>
          </div>
        )}
        
        <button data-cta="true" data-testid="cta-whats-app-button-contact"
          onClick={() => setIsOpen(!isOpen)}
          className="heelpy-whatsapp-launcher bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-110 group"
          aria-label="Contacter sur WhatsApp"
        >
          {isOpen ? (
            <X className="w-7 h-7" />
          ) : (
            <MessageCircle className="w-7 h-7 group-hover:animate-bounce" />
          )}
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;